angular.module('inspinia').directive('materialIcon', () => {
  return {
    restrict: 'E',
    scope: {
      name: '@',
      width: '@',
      height: '@',
    },
    templateUrl: `/manage/src/view/directive/material_icon.html?${new Date().getTime()}`,
    link($scope) {
      /**
       * CSSのクラス名を返す
       * @returns {string} material-icon
       */
      $scope.materialIconClasses = () => {
        return `material-icon`;
      };
      $scope.width = $scope.width ?? 24;
      $scope.height = $scope.width ?? 24;
    },
  };
});
